import moment from 'moment-timezone'

import { BaseModel } from '../base-model'
import { BaseModelData } from '../base-model-data'
import { Facility } from '../facility'
import { ProductModel } from '../product'

export interface ChargeDescriptionMasterData extends BaseModelData {
  product: ProductModel
  productId: string
  location: Facility
  facilityId: string
  type: ChargeDescriptionMaster.TYPE
  chargeType: ChargeDescriptionMaster.CHARGE_TYPE
  chargeCode: string
  chargeDescription?: string
  revCode: string
  cptCode: string
  hcpcsCode: string
  departmentCode: string
  departmentDescription?: string
  unitCharge: number
  quantity: number
  effectiveDate: moment.Moment
}

export class ChargeDescriptionMasterModel extends BaseModel {
  productId: string
  facilityId: string
  type: ChargeDescriptionMaster.TYPE
  chargeType: ChargeDescriptionMaster.CHARGE_TYPE
  chargeCode: string
  chargeDescription?: string
  revCode: string
  cptCode: string
  hcpcsCode: string
  departmentCode: string
  departmentDescription?: string
  unitCharge: number
  quantity: number
  effectiveDate: moment.Moment

  constructor(data?: any) {
    super(data, true)

    this.productId = data?.productId || ''
    this.facilityId = data?.facilityId || ''
    this.type = data?.type || ChargeDescriptionMaster.TYPE.PB
    this.chargeType = data?.chargeType || ChargeDescriptionMaster.CHARGE_TYPE.CHARGE
    this.chargeCode = data?.chargeCode || ''
    this.chargeDescription = data?.chargeDescription
    this.revCode = data?.revCode || ''
    this.cptCode = data?.cptCode || ''
    this.hcpcsCode = data?.hcpcsCode || ''
    this.departmentCode = data?.departmentCode || ''
    this.departmentDescription = data?.departmentDescription
    this.unitCharge = data?.unitCharge || 0
    this.quantity = data?.quantity || 0
    this.effectiveDate = this.transformDate(data?.effectiveDate)
  }

  override toJSON() {
    return {
      id: this.id,
      productId: this.productId,
      facilityId: this.facilityId,
      type: this.type,
      chargeType: this.chargeType,
      chargeCode: this.chargeCode,
      chargeDescription: this.chargeDescription || '',
      revCode: this.revCode,
      cptCode: this.cptCode,
      hcpcsCode: this.hcpcsCode,
      departmentCode: this.departmentCode,
      departmentDescription: this.departmentDescription || '',
      unitCharge: this.unitCharge,
      quantity: this.quantity,
      effectiveDate: this.effectiveDate,
    }
  }
}

export namespace ChargeDescriptionMaster {
  export enum CHARGE_TYPE {
    CHARGE = 'CHARGE',
    INSPMT = 'INSPMT',
    PATPMT = 'PATPMT',
    CONTALLOW = 'CONTALLOW',
  }

  export enum TYPE {
    PB = 'pb',
    HB = 'hb',
  }
}
